import React, { useEffect, useState } from "react";

import { parsedRedirectUrlFromSearch } from "lib/search-params";
import { useSessionStorage } from "ui/hooks";
import { AuthTemplate } from "ui/components/_templates";

import { AuthForm } from "./AuthForm";

const labelMapFromDomain = {
  map: "TalentBoost",
  app: "TalentScore",
};
const loginLabel = (redirectUrl: string | null) => {
  if (redirectUrl?.includes("boost.")) {
    return labelMapFromDomain.map;
  } else if (redirectUrl?.includes("app.")) {
    return labelMapFromDomain.app;
  } else {
    return "";
  }
};

export const LoginView: React.FC = () => {
  const [, writeRedirectUrl] = useSessionStorage("redirectUrl");
  const [, writeRedirectTimestamp] = useSessionStorage("redirectUrlTimestamp");
  const [redirectUrl] = useState(parsedRedirectUrlFromSearch());

  useEffect(() => {
    if (redirectUrl && redirectUrl.indexOf("http") === 0) {
      writeRedirectUrl(redirectUrl);
      writeRedirectTimestamp(Date.now());
    }
  }, [writeRedirectUrl, writeRedirectTimestamp, redirectUrl]);

  return (
    <AuthTemplate title={`Log in to your ${loginLabel(redirectUrl)} account.`}>
      <AuthForm />
    </AuthTemplate>
  );
};
